<template>
  <div>
    <mdb-navbar
      class="flexible-navbar cloudy-knoxville-gradient"
      position="top"
      :toggler="false"
    >
      <mdb-navbar-brand>
        <img
          :src="require('@/assets/logo2.png')"
          class="mr-2"
          alt="HospizWare Logo"
        />
        <strong>HospizWare APP</strong>
      </mdb-navbar-brand>
      <mdb-navbar-nav class="right-nav" right>
        <mdb-nav-item @click="modal = !modal">
          <mdb-icon icon="envelope" />
          <span class="clearfix d-none d-sm-inline-block">Neuigkeiten</span>
        </mdb-nav-item>
        <mdb-dropdown class="nav-item" tag="li">
          <mdb-dropdown-toggle slot="toggle" tag="li" outline="none" class="btn-transparent">
            <mdb-icon icon="user-md"/> <span class="clearfix d-none d-sm-inline-block"></span>
          </mdb-dropdown-toggle>
          <mdb-dropdown-menu left>
            <mdb-dropdown-item @click="logout">Abmelden ({{ this.loginUser.username }})</mdb-dropdown-item>
          </mdb-dropdown-menu>
        </mdb-dropdown>
      </mdb-navbar-nav>
    </mdb-navbar>

    <news-modal
      :modal-state="modal"
      @close="modal=false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarNav,
  mdbDropdown,
  mdbNavItem,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbIcon
} from 'mdbvue'

const NewsModal = () => import('@/components/modals/NewsModal')
import utils from '@/mixins/Utils'

export default {
  name: 'Navbar',
  mixins: [utils()],
  props: {
    page: {
      type: String
    }
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarNav,
    mdbDropdown,
    mdbNavItem,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbIcon,
    NewsModal
  },

  data () {
    return {
      modal: false
    }
  },

  methods: {
    ...mapActions('auth', ['resetUser']),

    logout() {
      this.resetUser()
      this.$router.push({ name: 'Login' });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem; }

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover, .btn-transparent:active {
  box-shadow: none !important;
}

</style>
